import { render, staticRenderFns } from "./HelpAdviseForm.vue?vue&type=template&id=5dd0b590&scoped=true"
import script from "./HelpAdviseForm.vue?vue&type=script&lang=ts"
export * from "./HelpAdviseForm.vue?vue&type=script&lang=ts"
import style0 from "./HelpAdviseForm.vue?vue&type=style&index=0&id=5dd0b590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd0b590",
  null
  
)

export default component.exports